function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import React from "react";
var _ref = /*#__PURE__*/React.createElement("g", {
  fill: "none",
  fillRule: "evenodd"
}, /*#__PURE__*/React.createElement("g", {
  fillRule: "nonzero"
}, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
  fill: "#3B5998",
  d: "M0 12C0 5.373 5.373 0 12 0s12 5.373 12 12-5.373 12-12 12S0 18.627 0 12z",
  transform: "translate(-1025 -955) translate(1025 903) translate(0 52)"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#FFF",
  d: "M13.25 19.056v-6.529h1.803l.239-2.25H13.25l.003-1.126c0-.587.056-.9.898-.9h1.127V6h-1.802c-2.165 0-2.927 1.091-2.927 2.927v1.35H9.2v2.25h1.35v6.529h2.7z",
  transform: "translate(-1025 -955) translate(1025 903) translate(0 52)"
})))));
const SvgIcSocialFacebook = ({
  svgRef,
  title,
  ...props
}) => /*#__PURE__*/React.createElement("svg", _extends({
  width: 24,
  height: 24,
  viewBox: "0 0 24 24",
  ref: svgRef
}, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref);
const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgIcSocialFacebook, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/ic-social-facebook.dce58b51.svg";
export { ForwardRef as ReactComponent };